export const GetUsersRequestedFields = [
  "id",
  "user_id",
  "school_id",
  "external_id",
  "group",
  "firstname",
  "lastname",
  "patronymic",
  "username",
  "email",
  "phone",
  "photo",
  "color",
  "description",
  "is_need_complete_challenge",
  "is_online",
  "student",
];

export const GetStudentsAsManagerFullInfoRequestedFields = [
  "id",
  "user_id",
  "user:id",
  "user:school_id",
  "user:external_id",
  "user:group",
  "user:firstname",
  "user:lastname",
  "user:patronymic",
  "user:username",
  "user:email",
  "user:phone",
  "user:photo",
  "user:photo_thumb",
  "user:color",
  "user:description",
  "user:is_need_complete_challenge",
  "user:is_online",
];

/**
 * Поля для GET /users/{id} перед PUT /users/{id}.
 *
 * Бэкенд обновляет пользователя через UserValidator::extract($request->all())
 * БЕЗ контекста модели: любое отсутствующее поле подменяется дефолтом
 * (NULL, status=activated, group=student). Поэтому PUT обязан нести полный
 * набор полей валидатора, а собрать его можно только из свежего GET.
 *
 * Список = UserValidator::defaults() минус password (пустой пароль extract
 * пропускает). color и photo_thumb в defaults не входят — PUT их не трогает.
 */
export const GetUserEditableProfileRequestedFields = [
  "id",
  "school_id",
  "external_id",
  "auth_type",
  "status",
  "group",
  "photo",
  "firstname",
  "lastname",
  "patronymic",
  "username",
  "email",
  "phone",
  "description",
  "additional",
  /*
   * Документы студента (сертификаты и дипломы) — связь hasMany, которую отдаёт
   * Traits\RequestModelAttributes. Отдельного эндпоинта для чужих документов нет:
   * UserCertificatesController::index() жёстко отдаёт только свои.
   *
   * ВАЖНО: в UserValidator::defaults() поля нет, поэтому в PUT /users/{id} его
   * отправлять нельзя и в проверку полноты профиля включать тоже не нужно.
   */
  "certificates:id",
  "certificates:name",
  "certificates:certificate",
];
